import * as React from 'react';
import * as styles from './navigation-hero.css';

export interface INavigationHeroProps {
  backgroundImage?: string;
  navigation?: any;
}

export class NavigationHero extends React.Component<INavigationHeroProps, {}> {
  constructor(props) {
    super(props);
  }

  backgroundImage = require(`../../../../assets/images/discover-header.jpg`);

  render() {
    return (
      <div
        className={styles.imageBanner}
        style={{ backgroundImage: `url(${this.props.backgroundImage})` }}
      >
        {this.props.navigation && this.props.navigation}
        <div className={styles.container}>
          <div className={styles.row}>
            <div className={styles.col12}>
              <div className={styles.imageBannerContent}>{this.props.children}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
